import * as React from 'react';
import 'classnames';
import '@swc/helpers';
import '@grandvisionhq/common';
import '@grandvisionhq/elements';
import '@grandvisionhq/lib-utils-html';
import '@grandvisionhq/iris-ui';
import '@grandvisionhq/state';
import '@grandvisionhq/lib-visuals';
import '@grandvisionhq/utils';
import '@grandvisionhq/configurator';
import '@grandvisionhq/frk-routing';
import '@grandvisionhq/api-client';
import '../../../state/actions.js';
import '../../../state/add-to-cart/selectors.js';
import '../../../state/bundles/selectors.js';
import '../../../state/bundles/reducer.js';
import '../../../state/configurator/selectors.js';
import '../../../state/configurator/reducer.js';
import '../../../state/products/selectors.js';
import '../../../state/products/reducer.js';
import '@grandvisionhq/commercetools';
import '@grandvisionhq/icons';
import { SelectionsSummary } from '../../SelectionsSummary/SelectionsSummary.js';

const RxGlassesExpanderContent = ()=>{
    return /*#__PURE__*/ React.createElement("div", {
        className: "rx-glasses-expander-content"
    }, /*#__PURE__*/ React.createElement(SelectionsSummary, null));
};

export { RxGlassesExpanderContent };
//# sourceMappingURL=RxGlassesExpanderContent.js.map
